import { i as isElement } from './instanceOf-DT24G-dX.js';

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

export { getDocumentElement as g };
//# sourceMappingURL=getDocumentElement-CF55JRdX.js.map
